import React from "react";
import Lottie from "lottie-react";
import home from "../LottieFiles/home.json";
import Typed from "./Typed.js";
import Tilt from "react-parallax-tilt";
import Avatar from "../images/Avatar.png";

const Home = () => {
  return (
    <div>
      <div className="HomePage">
        <div className="HomeText">
          <h1>Hi There!</h1>
          <h1>
            I'M <b>GOPI MISHRA</b>
          </h1>
          <Typed />
        </div>

        <Lottie className="illustration" animationData={home} loop={true} />
      </div>

      <div className="AboutPage">
        <div className="AboutText">
          <h1 className="AboutTextHeading">
            <b>Introduction</b>
          </h1>
          <p>
            As a dedicated full stack developer with a BCA degree, I thrive on
            turning ideas into dynamic web applications. My passion lies in both
            front-end and back-end development, and I’m always eager to take on
            new challenges.
            <br />
            <br />
            Beyond web development, I have a keen interest in{" "}
            <b>
              cybersecurity, software development, app development, Web3, and
              AI.
            </b>{" "}
            I enjoy exploring cutting-edge technologies and am committed to
            continuous learning. <br />
            <br />
            Join me on this journey as I create innovative solutions that make a
            difference!
          </p>
        </div>
        <Tilt>
          <img className="Avatar" src={Avatar} alt="" />
        </Tilt>
      </div>
    </div>
  );
};

export default Home;
